import {DefaultShopClass} from "./DefaultShopClass";

let dateRange = "";

/**
 *  Класс описывающий реализацию фильтра
 * @extends DefaultShopClass
 * @param $dateRangeInputs - Кнопки выбора периода {@link CalendarShop#setDateRangeInputs}
 */
export class FilterShop extends DefaultShopClass {
	constructor() {
		super();
		this.$filterClear = null;
		this.$filters = null;
		this.$calendarInput = null;
		this.$calendarLabel = null;
		this.$dateRangeInputs = $(".js-date-range-input");
		this.$more = $("#js-more");
		this.$message = null;
		this.$inputs = $(".js-filter-input");
		this.currentDate = new Date();
		this.calendar = null;
		this.$dropdowns = $(".js-dropdown-filter");
		this.$filterSwitch = $("#js-filter-switch");
		this.$filterSwitchInput = $("#js-switch-input");
		this.objects = [];
		this.noms = [];
		this.eventTypes = [];
		this.hasParking = null;
		this.page = 0;
		this.count = 3;
		this.mobileInputs = $(".js-date-input");
		this.mobileInputFirst = $(".js-date-input-first");
		this.mobileInputSecond = $(".js-date-input-second");
	}

	get page() {	
		return localStorage.getItem('page');
	}

	set page(pageNumber) {
		localStorage.setItem('page', pageNumber);
	}

	init() {
		this.changeFilters();
		this.changeDropdowns();
		this.viewFilters();
		this.clear();
	}

	viewFilters() {
		this.$filterTitle.on("click", () => {
			this.$filterTitle.toggleClass("active");
			this.$filterWrapper.slideToggle();
		});
	}

	getRequest(mode = "replace") {
		return this.search({
			page: this.page,
			dateRange,
			objects: this.objects,
			noms: this.noms,
			eventTypes: this.eventTypes,
			hasParking: this.hasParking,
		}).then(response => {
			this.updateItems(response, mode);
		});
	}

	getDate(data) {
		const date = new Date(data);
		const dateYear = date.getFullYear();
		const dateMonth = ("0" + (date.getMonth() + 1)).slice(-2);
		const dateDay = ("0" + date.getDate()).slice(-2);
		return `${dateDay}-${dateMonth}-${dateYear}`;
	}

	setFilterValues(date) {
		this.objects = [];
		this.noms = [];
		this.eventTypes = [];
		dateRange = "";
		$(".js-dropdown-filter").each((index, element) => {
			const dropdownFilter = $(element);
			const checkboxes = dropdownFilter.find(".checkbox__input");
			const filterName = dropdownFilter.data("select");
			checkboxes.each((i, item) => {
				const id = $(item).data("id");
				if (item.checked) {
					if (filterName === "unit") {
						this.objects.push(id);
					}
					if (filterName === "nom") {
						this.noms.push(id);
					}
					if (filterName === "all") {
						const select = $(item).data("select");
						this.eventTypes.push(select);
					}
				}
			});
		});

		if (this.isDesktop.matches) {
			if (!$(".applyBtn").hasClass("hadDisabled")) {
				const $filterDateInput = $(".js-datepicker-filter");
				const picker = $filterDateInput.data("daterangepicker");

				const formatStart = this.getDate(picker.startDate);
				const formatEnd = this.getDate(picker.endDate);
				if (formatStart === formatEnd) {
					dateRange = picker.startDate.format("DD-MM-YYYY");
					$filterDateInput.val(dateRange);
				} else {
					dateRange =
						picker.startDate.format("DD-MM-YYYY") +
						" — " +
						picker.endDate.format("DD-MM-YYYY");
					$filterDateInput.val(dateRange);
				}
				if (
					!$(".js-filter-date").hasClass("alone") &&
					!$(".js-filter-date").hasClass("double")
				) {
					dateRange = "";
					$filterDateInput.val(this.getWord("main", "Date")).addClass("input");
				}
			} else {
				const $filterDateInput = $(".js-datepicker-filter");
				const picker = $filterDateInput.data("daterangepicker");
				if (date) {
					dateRange = picker.startDate.format("DD-MM-YYYY");
					if (picker.endDate) {
						dateRange += " — " + picker.endDate.format("DD-MM-YYYY");
					}
				}
			}
		} else {
			if (this.mobileInputFirst.val()) {
				dateRange = this.getDate(this.mobileInputFirst.val());
			}
			if (this.mobileInputSecond.val()) {
				if (!this.mobileInputFirst.val()) {
					dateRange = new Date();
				} else {
					dateRange = this.getDate(this.mobileInputFirst.val());
				}
				dateRange += " — " + this.getDate(this.mobileInputSecond.val());
			}
		}

		$.each(this.$inputs, (index, element) => {
			const input = $(element);
			if (input.hasClass("active")) {
				const from = input.data("date-from");
				const to = input.data("date-to");
				dateRange = `${from} — ${to}`;
			}
		});
	}

	updateItems(response, mode = "replace") {
		if (response.html.length) {
			if (mode === "replace") this.$items.html(response.html);
			else this.$items.append(response.html);
			this.$message.hide();
			this.$more.removeClass("inactive");
		} else {
			if (mode === "replace") this.$items.html(response.html);
		}
		if (response.eventsCount <= 0) {
			this.$more.addClass("inactive");
		}
	}

	formatDate(time) {
		dateRange = [];
		for (let i = 0; i < time.length; i++) {
			let date = new Date(time[i]);
			const day = date.toLocaleString("ru", {day: "2-digit"});
			const month = date.toLocaleString("ru", {month: "2-digit"});
			const year = date.toLocaleString("ru", {year: "2-digit"});
			date = `${day}-${month}-${year}`;

			dateRange.push(date);
		}
		if (dateRange) {
			dateRange = dateRange.join(" — ");
		}
		return dateRange;
	}

	changeFilters() {
		this.$filters.on("change", e => {
			const filter = $(e.currentTarget);
			if (filter.prop("checked")) {
				this.$calendarLabel.text("Выбрать дату");
				this.$filterClear.addClass("active");
				const from = filter.data("date-from");
				const to = filter.data("date-to");
				dateRange = `${from} — ${to}`;
				this.$filters.removeClass("active");
				filter.addClass("active");
			}
			this.page = 0;
			this.setFilterValues();
			this.getRequest();
		});
	}

	clear() {
		this.$filterClear.on("click", () => {
			this.$filters.removeAttr("checked");
			$.each($(".checkbox__input"), (i, el) => {
				$(el).prop("checked", false);
			});
			$(".js-datepicker-filter").val(this.getWord("main", "Date"));
			$(".js-dropdown-filter").each((i, el) => {
				const currentDropdownFilter = $(el);
				const currentDropdownBtn = currentDropdownFilter.find(".dropdown__btn");
				const currentPreviousText = currentDropdownBtn.data("previous");
				const text = currentDropdownBtn.find(".filter__selected-text");
				const currentCount = currentDropdownBtn.find(".filter__selected-count");
				text.text(currentPreviousText);
				currentCount.removeClass("active").text(0);
			});
			$(".filter__input").val("");
			$(".filter__apply").trigger("click");
			this.$calendarLabel.text(this.getWord("event", "Select date"));
			$("#filter-date").val(this.getWord("main", "Date"));
			this.$filterClear.removeClass("active");
			this.$inputs.removeClass("active");
			this.eventTypes = [];
			this.$filterSwitchInput.prop("checked", true);
			this.$filterSwitch.addClass("active");
			$(".js-filter-date").removeClass("alone double opened visible");
			this.mobileInputs.val("");
			this.mobileInputs.parents(".dates__label").removeClass("active");
			this.$dateRangeInputs.prop("checked", false).removeClass("active"); //Очистить кнопки выбора периода
			this.page = 0;
			this.hasParking = null;
			this.setFilterValues();
			this.getRequest();
			const year = new Date().getFullYear();
			let month = new Date().getMonth() + 1;
			month = month >= 10 ? month : "0" + month;
			let day = new Date().getDate();
			day = day >= 10 ? day : "0" + day;
			this.mobileInputFirst.val(`${year}-${month}-${day}`);
		});
	}

	changeDropdowns() {
		this.$dropdowns.each((index, element) => {
			const dropdownFilter = $(element);
			const dropdownBtn = dropdownFilter.find(".dropdown__btn");
			const checkboxes = dropdownFilter.find(".checkbox__input");
			const previousText = dropdownBtn.data("previous");
			const filterReset = dropdownFilter.find(".js-filter-reset");
			const filterName = dropdownFilter.data("select");
			const selectedCount = dropdownFilter.find(".filter__selected-count");

			let count = 0;

			const changeCheckbox = item => {
				this.page = 0;
				count = Number(selectedCount.text());
				const id = $(item).data("id");
				if (item.checked) {
					count++;
					if (filterName === "unit") {
						this.objects.push(id);
					}
					if (filterName === "nom") {
						this.noms.push(id);
					}
					if (filterName === "all") {
						const select = $(item).data("select");
						this.eventTypes.push(select);
					}
				} else {
					count--;
					if (filterName === "unit") {
						const index = this.objects.indexOf(item);
						this.objects.splice(index, 1);
					}
					if (filterName === "nom") {
						const index = this.noms.indexOf(item);
						this.noms.splice(index, 1);
					}
					if (filterName === "all") {
						const select = $(item).data("select");
						const index = this.eventTypes.indexOf(select);
						this.eventTypes.splice(index, 1);
					}
				}
				if (count) {
					selectedCount.addClass("active");
					this.$filterClear.addClass("active");
					dropdownBtn.find(".filter__selected-text").text(dropdownBtn.data("text"));
					dropdownBtn.find(".filter__selected-count").text(count).show();
				} else {
					selectedCount.removeClass("active");
					this.$filterClear.removeClass("active");
					dropdownBtn.find(".filter__selected-text").text(previousText);
					dropdownBtn.find(".filter__selected-count").text(0).hide();
				}

				this.page = 0;
				this.setFilterValues();
				this.getRequest();
			};

			checkboxes.each((i, item) => {
				$(item).on("change", () => {
					changeCheckbox(item);
				});

				$(item).on("keydown", e => {
					if (e.code === "Enter" || e.code === "NumpadEnter") {
						changeCheckbox(item);
					}
				});
			});

			const setResetCurrentFilter = () => {
				dropdownBtn.find(".filter__selected-text").text(previousText);
				dropdownBtn.find(".filter__selected-count").text(0).hide();
				checkboxes.each((i, item) => {
					item.checked = false;
				});

				if (filterName === "unit") {
					this.objects = [];
				}
				if (filterName === "nom") {
					this.noms = [];
				}

				if (filterName === "all") {
					this.eventTypes = [];
				}
				this.page = 0;
				this.setFilterValues();
				this.getRequest();
			};

			filterReset.on("click", () => setResetCurrentFilter());

			filterReset.on("keydown", e => {
				if (e.code === "Enter" || e.code === "NumpadEnter") {
					setResetCurrentFilter();
				}
			});
		});
	}
}
